/*
 * @Author: yangchong
 * @Description: 协同办公多语言配置包
 * @Date: 2019-11-30 15:15:06
 */
export default {
  '序号': '序號',
  '其他平台': '其他平臺',
  '自动获取': '自動獲取',
  '丽晶360终端物流': '麗晶360終端物流',
  'POS自动填充收银员账号&密码': 'POS自動填充收銀員賬號&密碼',
  '协同平台设置': '協同平臺設置',
  '平台名称': '平臺名稱',
  '网址': '網址',
  '输入平台名称': '輸入平臺名稱',
  '输入网址': '輸入網址',
  '需填写http': '需填寫http',
  '确定删除该记录吗？': '確定刪除該記錄嗎？',
  '新增成功': '新增成功',
  '保存成功': '保存成功',
  '请输入平台名称': '請輸入平臺名稱',
  '请输入网址': '請輸入網址',
  '请输入正确的网址': '請輸入正確的網址',
  '删除成功': '刪除成功',
  '新增': '新增',
  '储位系统': '儲位系統',
  '店铺储位管理系统': '店鋪儲位管理系統',
  '自定义排序': '自定義排序',
  '是否取消自定义排序？': '是否取消自定義排序？',
  '已经是第一条，不可上': '已經是第壹條，不可上',
  '已经是最后一条，不可下移': '已經是最後壹條，不可下移',
  '修改成功': '修改成功',
  '取消': '取消',
  '保存': '保存',
  '平台类型': '平臺類型',
  '外挂': '外掛',
  'RP': 'RP'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-hant/collaboraivePlatform.js